import { Injectable } from '@angular/core';

/**
 * Shared service that stores the current sorted list of IDs
 * from the parent list component (transfer or mandate).
 * The edit component reads from this to navigate prev/next.
 */
@Injectable({
  providedIn: 'root',
})
export class NavigationListService {

  // Transfer list: sorted IDs from the current page
  private transferIds: number[] = [];

  // Mandate list: sorted IDs from the current page
  private mandateIds: number[] = [];

  // --- Transfer ---

  setTransferIds(ids: number[]) {
    this.transferIds = ids;
  }

  getTransferIds(): number[] {
    return this.transferIds;
  }

  getPrevTransferId(currentId: number): number | null {
    const idx = this.transferIds.findIndex(id => +id === +currentId);
    if (idx > 0) {
      return this.transferIds[idx - 1];
    }
    return null; // already first or not found
  }

  getNextTransferId(currentId: number): number | null {
    const idx = this.transferIds.findIndex(id => +id === +currentId);
    if (idx >= 0 && idx < this.transferIds.length - 1) {
      return this.transferIds[idx + 1];
    }
    return null; // already last or not found
  }

  // --- Mandate ---

  setMandateIds(ids: number[]) {
    this.mandateIds = ids;
  }

  getMandateIds(): number[] {
    return this.mandateIds;
  }

  getPrevMandateId(currentId: number): number | null {
    const idx = this.mandateIds.findIndex(id => +id === +currentId);
    if (idx > 0) {
      return this.mandateIds[idx - 1];
    }
    return null;
  }

  getNextMandateId(currentId: number): number | null {
    const idx = this.mandateIds.findIndex(id => +id === +currentId);
    if (idx >= 0 && idx < this.mandateIds.length - 1) {
      return this.mandateIds[idx + 1];
    }
    return null;
  }

  // Position info (e.g. "3 / 50")
  getTransferPosition(currentId: number): string {
    const idx = this.transferIds.findIndex(id => +id === +currentId);
    if (idx >= 0) {
      return `${idx + 1} / ${this.transferIds.length}`;
    }
    return '';
  }

  getMandatePosition(currentId: number): string {
    const idx = this.mandateIds.findIndex(id => +id === +currentId);
    if (idx >= 0) {
      return `${idx + 1} / ${this.mandateIds.length}`;
    }
    return '';
  }
}
